<template>
  <div class="flex w-full justify-center">
    <div class="navigation_button"
         @click="$emit('back')">
      <img src="../../assets/icons/angle-left.svg">
    </div>
    <div v-if="!lastStep" class="navigation_button ml-1"
         :class="{'disabled_button': forwardDisabled}"
         @click="sendContinue">
      <img src="../../assets/icons/angle-right.svg">
    </div>
    <div v-if="lastStep" class="navigation_button_last_step ml-1"
         :class="{'disabled_button': forwardDisabled}"
         @click="sendContinue">
      <p>{{ $t('components.requestMeeting') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationButtons',

  props: {
    forwardDisabled: {
      required: false,
      default: false
    },
    lastStep: {
      required: false,
      default: false
    }
  },

  methods: {
    sendContinue() {
      if (this.forwardDisabled) {
        return;
      }

      this.$emit('continue');
    }
  }
};
</script>
<style scoped>
.navigation_button, .navigation_button_last_step {
  height: 35px;
  @apply bg-cebeo_blue flex items-center justify-center text-white cursor-pointer
}

.navigation_button_last_step {
  width: 260px;
}

.navigation_button {
  width: 35px;
}

.disabled_button {
  @apply opacity-40;
}
</style>
